import React from "react"
import { StaticQuery, graphql } from "gatsby"

import Page from "./Page"

export default props => (
  <StaticQuery
    query={graphql`
      query LayoutQuery {
        site {
          siteMetadata {
            title
            authRoutes
            onboardRoutes
          }
        }
      }
    `}
    render={data => {
      let cleanPath = props.location.pathname.split("/")[1]
      if (cleanPath=='') {cleanPath='Home'}
      const useAuth = data.site.siteMetadata.authRoutes.includes(cleanPath)
      const isOnboarding =  data.site.siteMetadata.onboardRoutes.includes(cleanPath)
      const login = ['login'].includes(cleanPath)
      return (
        <Page
          displayFooter={!useAuth && !isOnboarding}
          isOnboarding={isOnboarding}
          login={login}
          displayNav={!useAuth || isOnboarding}
          onAuthCheck={useAuth ? authUser => !!authUser : null}
          {...props}
        />
      )
    }}
  />
)
